import { render, staticRenderFns } from "./OrderAddCustomItemModal.vue?vue&type=template&id=f6291f22&"
import script from "./OrderAddCustomItemModal.vue?vue&type=script&lang=js&"
export * from "./OrderAddCustomItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports